import { useState } from 'react';
// import { useDropzone } from 'react-dropzone';
// import { ArrowUpTrayIcon, XMarkIcon } from '@heroicons/react/24/outline';
// import { useAuth } from '../../util/auth';
// import { uploadGalleryClaimProof } from '../../util/util';

// const MAX_FILES = 5;
// const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
// const MAX_FILE_SIZE_LABEL = '10MB';

function AdminApplyStepInfo({ initialData, onBack, onNext }) {
  // const auth = useAuth(); // only needed for the proof-upload step, disabled below
  const [contactName, setContactName] = useState(initialData?.contactName || '');
  const [contactPhone, setContactPhone] = useState(initialData?.contactPhone || '');
  const [additionalInfo, setAdditionalInfo] = useState(initialData?.additionalInfo || '');
  const [validationError, setValidationError] = useState(null);

  // Proof of association file upload — disabled for now, keep for easy re-enable.
  // const [existingFiles, setExistingFiles] = useState(initialData?.proofFiles || []);
  // const [newFiles, setNewFiles] = useState([]);
  // const [uploading, setUploading] = useState(false);
  // const [rejectedFiles, setRejectedFiles] = useState([]);

  // const totalFileCount = existingFiles.length + newFiles.length;

  // const onDrop = (acceptedFiles, fileRejections) => {
  //   setRejectedFiles(
  //     fileRejections.map(({ file, errors }) => ({
  //       name: file.name,
  //       reason: errors.some(e => e.code === 'file-too-large')
  //         ? `exceeds the ${MAX_FILE_SIZE_LABEL} limit`
  //         : 'is not an accepted file type (image or PDF)',
  //     }))
  //   );

  //   if (acceptedFiles.length === 0) return;

  //   if (totalFileCount + acceptedFiles.length > MAX_FILES) {
  //     setValidationError(`You can attach up to ${MAX_FILES} files`);
  //     return;
  //   }
  //   setValidationError(null);
  //   setNewFiles(prev => [...prev, ...acceptedFiles]);
  // };

  // const { getRootProps, getInputProps, isDragActive } = useDropzone({
  //   onDrop,
  //   accept: { 'image/*': [], 'application/pdf': ['.pdf'] },
  //   multiple: true,
  //   disabled: uploading || totalFileCount >= MAX_FILES,
  //   maxSize: MAX_FILE_SIZE_BYTES,
  // });

  // const removeExistingFile = path => {
  //   setExistingFiles(prev => prev.filter(f => f.path !== path));
  // };

  // const removeNewFile = index => {
  //   setNewFiles(prev => prev.filter((_, i) => i !== index));
  // };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!contactName.trim()) {
      setValidationError('Please enter your name');
      return;
    }
    setValidationError(null);

    // Proof of association file upload — disabled for now, keep for easy re-enable.
    // let uploadedFiles = [];
    // if (newFiles.length > 0) {
    //   setUploading(true);
    //   try {
    //     uploadedFiles = await Promise.all(
    //       newFiles.map(file => uploadGalleryClaimProof(auth.user.id, file))
    //     );
    //   } catch (error) {
    //     setUploading(false);
    //     setValidationError(`Failed to upload file: ${error.message}`);
    //     return;
    //   }
    //   setUploading(false);
    // }

    onNext({
      contactName: contactName.trim(),
      contactPhone: contactPhone.trim(),
      additionalInfo: additionalInfo.trim(),
      // proofFiles: [...existingFiles, ...uploadedFiles],
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <h2 className="text-lg font-medium text-slate-700">Tell us about yourself</h2>

      {validationError && <div className="text-xs text-secondary-red">{validationError}</div>}

      <div className="flex flex-col">
        <label className="text-sm font-medium text-slate-700 mb-1" htmlFor="contactName">
          Your Name <span className="text-secondary-red">*</span>
        </label>
        <input
          id="contactName"
          type="text"
          className="input input-bordered text-sm py-2 px-3 h-9 focus:outline-none"
          value={contactName}
          onChange={e => setContactName(e.target.value)}
        />
      </div>

      <div className="flex flex-col">
        <label className="text-sm font-medium text-slate-700 mb-1" htmlFor="contactPhone">
          Phone Number <span className="text-slate-400">(optional)</span>
        </label>
        <input
          id="contactPhone"
          type="tel"
          className="input input-bordered text-sm py-2 px-3 h-9 focus:outline-none"
          value={contactPhone}
          onChange={e => setContactPhone(e.target.value)}
        />
      </div>

      {/* Proof of association file upload — disabled for now, keep for easy re-enable.
      <div className="flex flex-col">
        <label className="text-sm font-medium text-slate-700 mb-1">
          Proof of association (optional)
        </label>
        <p className="text-xs text-slate-400 mb-2">
          This is optional if you signed in with a gallery-affiliated email. Otherwise, please
          attach a business card, staff photo, or listing that shows your association with this
          gallery — up to {MAX_FILES} files, {MAX_FILE_SIZE_LABEL} each.
        </p>

        {rejectedFiles.length > 0 && (
          <div className="mb-4 rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
            {rejectedFiles.length === 1
              ? `"${rejectedFiles[0].name}" ${rejectedFiles[0].reason} and was not added.`
              : `These files were not added: ${rejectedFiles
                  .map(f => `"${f.name}" (${f.reason})`)
                  .join(', ')}`}
          </div>
        )}

        <div
          {...getRootProps()}
          className={`flex items-center gap-2 h-9 px-3 rounded-lg border text-sm transition-colors cursor-pointer focus:outline-none ${
            isDragActive
              ? 'border-secondary-red bg-slate-50 text-secondary-red'
              : 'border-slate-300 bg-white text-slate-400 hover:bg-slate-50'
          } ${totalFileCount >= MAX_FILES ? 'opacity-60 cursor-not-allowed hover:bg-white' : ''}`}
        >
          <input {...getInputProps()} />
          <ArrowUpTrayIcon className="h-4 w-4 shrink-0" />
          {totalFileCount >= MAX_FILES
            ? `Maximum ${MAX_FILES} files reached`
            : isDragActive
              ? 'Drop to add'
              : 'Click or drag to upload'}
        </div>

        {(existingFiles.length > 0 || newFiles.length > 0) && (
          <ul className="mt-2 flex flex-col gap-1">
            {existingFiles.map(file => (
              <li
                key={file.path}
                className="flex items-center justify-between text-xs text-slate-600 bg-slate-50 rounded px-2 py-1"
              >
                <span className="truncate">{file.name}</span>
                <button
                  type="button"
                  onClick={() => removeExistingFile(file.path)}
                  className="focus:outline-none"
                  aria-label={`Remove ${file.name}`}
                >
                  <XMarkIcon className="h-4 w-4 text-slate-400 hover:text-secondary-red" />
                </button>
              </li>
            ))}
            {newFiles.map((file, i) => (
              <li
                key={`${file.name}-${i}`}
                className="flex items-center justify-between text-xs text-slate-600 bg-slate-50 rounded px-2 py-1"
              >
                <span className="truncate">{file.name}</span>
                <button
                  type="button"
                  onClick={() => removeNewFile(i)}
                  className="focus:outline-none"
                  aria-label={`Remove ${file.name}`}
                >
                  <XMarkIcon className="h-4 w-4 text-slate-400 hover:text-secondary-red" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      */}

      <div className="flex flex-col">
        <label className="text-sm font-medium text-slate-700 mb-1" htmlFor="additionalInfo">
          Tell us about your org / why you're claiming this account
        </label>
        <textarea
          id="additionalInfo"
          rows={3}
          className="textarea textarea-bordered text-sm py-2 px-3 focus:outline-none resize-none"
          value={additionalInfo}
          onChange={e => setAdditionalInfo(e.target.value)}
        />
      </div>

      <div className="flex justify-end gap-2 mt-2">
        <button
          type="button"
          className="btn btn-outline btn-sm focus:outline-none"
          onClick={onBack}
        >
          Back
        </button>
        <button type="submit" className="btn btn-primary btn-sm focus:outline-none">
          Review
        </button>
      </div>
    </form>
  );
}

export default AdminApplyStepInfo;
